/**
 * Mirror of fides-capital-native-app/src/theme/ui.ts for CI/type-check when the
 * native app repo is not checked out. Keep in sync with the native app theme file.
 */
import { colors } from './colors';

export const ui = {
  screenPadding: 16,
  sectionGap: 16,
  cardRadius: 16,
  panelRadius: 12,
  touchRadius: 10,
  buttonRadius: 10,
  borderWidth: 0,
  cardBorderColor: colors.borderLight,
  cardElevation: 0,
  contentBottomPadding: 28,
};

export const pageContent = {
  paddingHorizontal: ui.screenPadding,
  paddingTop: ui.screenPadding,
  paddingBottom: ui.contentBottomPadding,
  gap: ui.sectionGap,
} as const;
